import { Button, Input, BaseModal, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from 'utils/api';
import { getKitchenTeam } from 'utils/functions';

type SetKpiProps = {
  show: boolean;
  onClose: () => void;
};

type KitchenTeamProps = {
  average_brand_rating_kpi: string;
  average_order_duration_kpi: string;
  completed_order_kpi: string;
  completed_order_percent_kpi: string;
  created_at: string;
  id: string;
  kitchen_time_duration_kpi: string;
  name: string;
  no_of_review_kpi: string;
  updated_at: string;
};
const SetKpisSideModal = ({ show, onClose }: SetKpiProps) => {
  const activeTeam: any = getKitchenTeam();
  const [values, setValues] = useState({
    dailyTarget: '',
    averageOrderDuration: '',
    averagePrepTime: '',
    averageBrandRating: '',
    completedOrders: '',
    reviews: ''
  });
  const [loading, setLoading] = useState(false);
  const [kitchenTeam, setKitchenTeam] = useState({} as KitchenTeamProps);

  const getKitchenTeamData = async () => {
    try {
      const res: any = await apiService.get('kitchen/team-shift', {
        baseUrl: 'https://order-api.getfoodcourt.com/v1/'
      });
      if (res) {
        const team = res.data.data.filter((item: any) => item.name === activeTeam);
        setKitchenTeam(team?.[0]);
      }
    } catch (err: any) {
      console.log(err);
    }
  };
  useEffect(() => {
    getKitchenTeamData();
  }, []);
  useEffect(() => {
    setValues({
      dailyTarget: kitchenTeam?.completed_order_kpi || '',
      averageOrderDuration: kitchenTeam?.average_order_duration_kpi || '',
      averagePrepTime: kitchenTeam?.kitchen_time_duration_kpi || '',
      completedOrders: kitchenTeam?.completed_order_percent_kpi || '',
      reviews: kitchenTeam?.no_of_review_kpi || '',
      averageBrandRating: kitchenTeam?.average_brand_rating_kpi || ''
    });
  }, [kitchenTeam]);

  const handleChange = (e: any) => {
    setValues((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value
      };
    });
  };
  const handleSubmitForm = async () => {
    setLoading(true);
    const payload = {
      kitchen_time_duration_kpi: values.averagePrepTime,
      completed_order_kpi: values.dailyTarget,
      completed_order_percent_kpi: values.completedOrders,
      no_of_review_kpi: values.reviews,
      average_brand_rating_kpi: values.averageBrandRating,
      average_order_duration_kpi: values.averageOrderDuration
    };
    try {
      await apiService.put(`kitchen/team-shift/${kitchenTeam.id}`, {
        baseUrl: 'https://order-api.getfoodcourt.com/v1/',
        data: payload
      });
      toast(<ToastMessage type='success' message='KPI updated successfully' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal position='right' isOpen={show} title='Set KPIs' onRequestClose={onClose}>
      <div className='space-y-6'>
        <Input
          label='Daily order target'
          placeholder='3,000 orders'
          name='dailyTarget'
          value={values.dailyTarget}
          onChange={handleChange}
        />
        <Input
          label='Average order duration'
          placeholder='25 mins'
          name='averageOrderDuration'
          value={values.averageOrderDuration}
          onChange={handleChange}
        />
        <Input
          label='Average prep time'
          placeholder='25 mins'
          name='averagePrepTime'
          value={values.averagePrepTime}
          onChange={handleChange}
        />
        <Input
          label='Successfully completed orders (%)'
          placeholder='50%'
          name='completedOrders'
          value={values.completedOrders}
          onChange={handleChange}
        />
        <Input
          label='No. of reviews'
          placeholder='25'
          name='reviews'
          value={values.reviews}
          onChange={handleChange}
        />
        <Input
          label='Average brand rating'
          placeholder='50'
          name='averageBrandRating'
          value={values.averageBrandRating}
          onChange={handleChange}
        />
        <div className='flex justify-end'>
          <Button
            small
            color='primary'
            variant='block'
            loading={loading}
            onClick={handleSubmitForm}
            className='w-[70%]'>
            Confirm
          </Button>
        </div>
      </div>
    </BaseModal>
  );
};

export default SetKpisSideModal;
